export const formatDuration = (duration) => {
  let m = Math.floor(duration / 60);
  m = m >= 10 ? m : `0${m}`;
  let s = Math.floor(duration % 60);
  s = s >= 10 ? s : `0${s}`;
  return `${m.startsWith('0') ? m.substring(1) : m}:${s}`;
};
